import React from 'react';
import {HeaderPortal} from '@rocket-ui/components';
import type {Task} from '@rocket-ui/lk-api';
import {OrderActionDrawers} from 'features/order-actions';
import type {CreateReceiptController, EmploymentMismatchController, SignAcceptanceController} from 'features/order-actions';
import {HeaderTitleBlock} from './HeaderTitleBlock';

export interface OrderPageHeaderProps {
	id: number;
	metaFull: string;
	metaSubtitle: string;
	statusLabel: string;
	acceptanceUri?: string | null;
	acceptanceCertificateUri?: string | null;
	type: Task['type'];
	signAcceptance: SignAcceptanceController;
	createReceipt: CreateReceiptController;
	employmentMismatch: EmploymentMismatchController;
	declineDrawer: {
		isOpen: boolean;
		step: 'confirm' | 'success';
		isDeclining: boolean;
		close: () => void;
		confirm: () => void;
		continueAfterSuccess: () => void;
	};
}

export function OrderPageHeader({
	id,
	metaFull,
	metaSubtitle,
	statusLabel,
	acceptanceUri,
	acceptanceCertificateUri,
	type,
	signAcceptance,
	createReceipt,
	employmentMismatch,
	declineDrawer,
}: OrderPageHeaderProps): React.ReactElement {
	return (
		<>
			<HeaderPortal position="left">
				<HeaderTitleBlock
					id={id}
					metaFull={metaFull}
					metaSubtitle={metaSubtitle}
					statusLabel={statusLabel}
					type={type}
				/>
			</HeaderPortal>
			<OrderActionDrawers
				task={{
					acceptanceUri: acceptanceUri ?? null,
					acceptanceCertificateUri: acceptanceCertificateUri ?? null,
				}}
				signAcceptance={signAcceptance}
				createReceipt={createReceipt}
				employmentMismatch={employmentMismatch}
				declineDrawer={declineDrawer}
			/>
		</>
	);
}
